var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType27(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,64C14.4,64,0,49.6,0,32S14.4,0,32,0s32,14.3,32,32S49.6,64,32,64z M32,4.9C17,4.9,4.9,17,4.9,32 S17,59.1,32,59.1S59.1,47,59.1,32S47,4.9,32,4.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.6,42.5c-0.5-1.1-1.8-1.6-2.9-1.1l-1.5,0.7L39,34.7c-0.3-0.7-1.1-1.1-1.9-1.1h-3.6v-2.4h2 c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2h-2v-1.3c0-1.2-1-2.2-2.2-2.2c-0.9,0-1.7,0.6-2,1.4c-5.3,0.3-10,3.7-12,8.6 c-1.5,3.4-1.5,7.2-0.1,10.7c1.4,3.5,4.1,6.2,7.5,7.7c1.7,0.7,3.6,1.1,5.5,1.1c4.5,0,8.8-2.2,11.3-5.8c0.2,0.1,0.4,0.1,0.7,0.1H43 l3.5-1.7C47.5,45,48,43.6,47.6,42.5z M26.5,47.5c-5-2.1-7.2-7.6-5.1-12.6c1.3-3.2,4.4-5.4,7.8-5.8v6.7c0,1.2,1,2.2,2.2,2.2h4.5 l2.8,5.1C36.4,47.5,31.2,49.5,26.5,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,11.2c-3.1,0-5.5,2.5-5.5,5.5s2.5,5.5,5.5,5.5s5.5-2.5,5.5-5.5S34.4,11.2,31.5,11.2z M31.5,19.1 c-1.4,0-2.4-1-2.4-2.4c0-1.5,1.2-2.4,2.4-2.4s2.4,0.9,2.4,2.4S32.8,19.1,31.5,19.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType27);
export default __webpack_public_path__ + "static/media/aioa-icon-type-27.1277812b72cfc5646db8804adfed47ba.svg";
export { ForwardRef as ReactComponent };